import { Typography } from "@mui/material";
import React from "react";
import AppointmentWrapper from "../../../components/wrappers/AppointmentWrapper";
export default function FutureAppointment({ appointement,marginTop }) {
  return (
    <AppointmentWrapper id={appointement?.id} status={appointement?.status} marginTop={marginTop}>
      <Typography variant="subtitle2">{appointement?.pet?.name}</Typography>
      <Typography variant="subtitle2">{appointement?.startDate}</Typography>
    </AppointmentWrapper>
  );
}
